import React, { Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import { SuspenseLoader } from '../components/SuspenseLoader';
import { PAGES } from '../utils/constants';

/**
 * Each logical "page" has a component. We want to
 * render them when the path matches the current URL.
 */

const Contact = React.lazy(() => import(/* webpackChunkName: "Contact" */ './Contact'));

const Reimbursement = React.lazy(() =>
  import(/* webpackChunkName: "Reimbursement" */ './Reimbursement')
);

const Confirmation = React.lazy(() =>
  import(/* webpackChunkName: "Confirmation" */ './Confirmation')
);

const TroubleshootingGuide = React.lazy(() =>
  import(/* webpackChunkName: "TroubleshootingGuide" */ './TroubleshootingGuide')
);

const CompleteScreen = React.lazy(() =>
  import(
    /* webpackChunkName: "CompleteScreen" */ './TroubleshootingGuide/components/CompleteScreen'
  )
);

const TroubleshootingConfirmation = React.lazy(() =>
  import(
    /* webpackChunkName: "TroubleshootingConfirmation" */ './TroubleshootingGuide/components/ConfirmationScreen'
  )
);

const PWRebateConfirmation = React.lazy(() =>
  import(/* webpackChunkName: "PWRebateConfirmation" */ './PowerwallRebate/ConfirmationScreen')
);

const UploadDocuments = React.lazy(() =>
  import(/* webpackChunkName: "UploadDocuments" */ './UploadDocuments')
);

const UploadDocumentsConfirmation = React.lazy(() =>
  import(/* webpackChunkName: "UploadDocumentsConfirmation" */ './UploadDocumentsConfirmation')
);

const GenerateIraDocumentConfirmation = React.lazy(() =>
  import(
    /* webpackChunkName: "GenerateIraDocumentConfirmation" */ './Contact/components/GenerateIraDocument/ConfirmationScreen'
  )
);

const GenerateIraDocumentTryAgain = React.lazy(() =>
  import(
    /* webpackChunkName: "GenerateIraDocumentTryAgain" */ './Contact/components/GenerateIraDocument/ErrorScreen'
  )
);

export default () => {
  return (
    <Suspense fallback={<SuspenseLoader show />}>
      <Switch>
        <Route
          path={PAGES.UPLOAD_DOCUMENTS_CONFIRMATION}
          exact
          component={UploadDocumentsConfirmation}
        />
        <Route path={PAGES.UPLOAD_DOCUMENTS} exact component={UploadDocuments} />
        <Route path={PAGES.REIMBURSEMENT_CONFIRM} exact component={Confirmation} />
        <Route path={PAGES.REIMBURSEMENT} exact component={Reimbursement} />
        <Route path={PAGES.SUCCESS} exact component={CompleteScreen} />
        <Route
          path={PAGES.TROUBLESHOOTING_CONFIRMATION}
          exact
          component={TroubleshootingConfirmation}
        />
        <Route path={PAGES.TROUBLESHOOTING} exact component={TroubleshootingGuide} />
        <Route path={PAGES.PW_REBATE_CONFIRMATION} exact component={PWRebateConfirmation} />
        <Route
          path={PAGES.GENERATE_IRA_DOCUMENT_CONFIRMATION}
          exact
          component={GenerateIraDocumentConfirmation}
        />
        <Route
          path={PAGES.GENERATE_IRA_DOCUMENT_TRY_AGAIN}
          exact
          component={GenerateIraDocumentTryAgain}
        />
        <Route path={PAGES.ROOT} exact component={Contact} />
      </Switch>
    </Suspense>
  );
};
